import { color } from '@upstox/upstox-ui';

export const rowContainer: CSSFunction<{
  atm: boolean;
  isDarkTheme: boolean;
}> = ({ cssProps, theme }) => {
  const { atm, isDarkTheme } = cssProps;
  const atmColor = isDarkTheme
    ? theme.colors.interactive.tan.hover
    : theme.colors.interactive.ui2.hover;
  return {
    height: 36,
    '&:hover': {
      '> td.actionCell': {
        width: 0,
        minWidth: 0,
      },
      '> td.actionCell > div.actionCellContainer': {
        display: 'block',
      },
      '> td': {
        background: color(
          theme,
          atm ? atmColor : theme.colors.interactive.row.hover,
        ),
      },
    },
    '> td': {
      borderLeft: '0',
      borderRight: '0',
      overflow: 'unset',
    },
    '&:first-of-type': {
      '> td': {
        borderTop: 0,
      },
    },
  };
};

export const separatorRow: CSSFunction = () => ({
  height: 0,
  position: 'sticky',
  top: 46,
  bottom: 10,
  zIndex: 3,
});

export const separatorCell: CSSFunction = () => ({
  height: 0,
  padding: 0,
  zIndex: 3,
  position: 'relative',
});

export const separator: CSSFunction = ({ theme }) => ({
  height: 1,
  border: `1px dashed ${theme.colors.interactive.primary.default}`,
  width: '100%',
  zIndex: 3,
  position: 'absolute',
  top: '0',
});

export const optionChainCell: CSSFunction = ({ theme }) => ({
  fontFamily: 'Messina Sans',
  color: color(theme, theme.colors.text[1]),
});
